import analytics, { EventTypeElementInteracted } from '@nerdwallet/analytics';

export const trackElementInteracted = ({
  entityName,
  action,
  interactionType,
  impressionId,
  onClick = () => {},
}: {
  entityName: string;
  action: EventTypeElementInteracted['Payload']['action'];
  interactionType: EventTypeElementInteracted['Payload']['interaction_type'];
  impressionId: EventTypeElementInteracted['Payload']['impression_id'];
  onClick?: () => void;
}) => {
  analytics.track('element_interacted', {
    entity_name: entityName,
    action,
    interaction_type: interactionType,
    impression_id: impressionId,
  });

  onClick();
};
